module.exports = __webpack_public_path__ + "media/images/logo-f334c969.png";